import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';

declare namespace NodeJS {
  interface ProcessEnv {
    GA_MEASUREMENT_ID?: string;
  }
}

let processMeasurementId: string | undefined;
try {
  processMeasurementId = process.env.GA_MEASUREMENT_ID;
} catch (err) {
  // ignore: process.env is undefined in the browser
}

const rawImportMetaEnv =
  typeof import.meta !== 'undefined' && (import.meta as any)?.env
    ? ((import.meta as any).env as Record<string, string | undefined>)
    : undefined;

const configuredMeasurementId = (
  processMeasurementId ??
  rawImportMetaEnv?.GA_MEASUREMENT_ID ??
  ''
).trim();

export const GOOGLE_ANALYTICS_MEASUREMENT_ID =
  configuredMeasurementId.length > 0 ? configuredMeasurementId : null;

const measurementIds = GOOGLE_ANALYTICS_MEASUREMENT_ID
  ? [GOOGLE_ANALYTICS_MEASUREMENT_ID]
  : null;

export const analytics =
  typeof window !== 'undefined' && measurementIds
    ? Analytics({
      app: 'selective-tests-web',
      plugins: [
        googleAnalytics({
          measurementIds,
        }),
      ],
    })
    : null;

export function trackPageView(path: string) {
  if (!analytics) return;
  analytics.page({
    path,
  });
}

export type AnalyticsEventProperties = Record<string, string | number | boolean | null | undefined>;

export type GoogleSignInSource = 'button' | 'one_tap';
export type GoogleSignInFailureReason =
  | 'invalid'
  | 'inactive'
  | 'collision'
  | 'transient'
  | 'configuration';

export function trackEvent(eventName: string, properties?: AnalyticsEventProperties) {
  if (!analytics || !eventName) return;
  analytics.track(eventName, properties ?? {});
}

export function trackGoogleSignInStarted(source: GoogleSignInSource) {
  trackEvent('google_sign_in_started', { source });
}

export function trackGoogleSignInSucceeded(
  source: GoogleSignInSource,
  accountCreated: boolean,
) {
  trackEvent('google_sign_in_succeeded', { source, accountCreated });
}

export function trackGoogleSignInFailed(
  source: GoogleSignInSource,
  reason: GoogleSignInFailureReason,
) {
  trackEvent('google_sign_in_failed', { source, reason });
}
